import 'moment/min/locales';

import { Button, CreateAlert, InputWraper, useForm } from 'modules';
import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { Routes } from '../../../AppRoutes';
import { InputNumber, InputText } from '../../../components';
import { translate } from '../../../languages';
import { AdminService } from '../../../services/admin';
import { transferWrapper } from '../components';

export const TransferToUser: FC = transferWrapper(() => {
  const navigate = useNavigate();

  const [dataPhoneValid, setDataPhoneValid] = useState<any>(null);
  const [isRequesting, setIsRequesting] = useState<boolean>(false);
  const [isRequestingPhoneValid, setIsRequestingPhoneValid] =
    useState<boolean>(false);

  const { handleSubmit, getInputProps, isSubmitting, resetForm } = useForm({
    enableReinitialize: true,
    structure: [
      {
        name: 'toUserId',
        validate: Yup.string()
          .required(translate('must-be-provided'))
          .matches(/^(\s*\+?\d+\s*|\s*\d+\s*)$/, 'Invalid phone number'),
        isDisabled: isRequesting || isRequestingPhoneValid,
      },
      {
        name: 'amount',
        validate: Yup.number()
          .typeError('Must be a number')
          .required(translate('must-be-provided'))
          .positive('Amount must be greater than 0'),
        isDisabled:
          dataPhoneValid == null ||
          dataPhoneValid.length === 0 ||
          isRequesting ||
          isRequestingPhoneValid
            ? true
            : false,
      },
      {
        name: 'reason',
        isDisabled:
          dataPhoneValid == null ||
          dataPhoneValid.length === 0 ||
          isRequesting ||
          isRequestingPhoneValid
            ? true
            : false,
      },
    ],
    onSubmit: async (values) => {
      const payload = {
        toUserId: dataPhoneValid?.id,
        amount: +values?.amount,
        reason: values?.reason,
      };
      setIsRequesting(true);
      return AdminService.handleTransferToUser(payload)
        .then(async (res: any) => {
          setDataPhoneValid(null);
          resetForm();
          CreateAlert({ message: 'Successfully!', type: 'success' });
        })
        .catch((err: any) => {
          CreateAlert({ message: err.message, type: 'danger' });
        })
        .finally(() => {
          setIsRequesting(false);
          navigate(Routes.transferList.path);
        });
    },
  });

  const handleCheckPhoneValid = () => {
    if (
      isRequestingPhoneValid === true ||
      (getInputProps('toUserId').value ?? '') === ''
    )
      return;
    setIsRequestingPhoneValid(true);
    setDataPhoneValid(null);
    AdminService.handleCheckPhoneValid(
      getInputProps('toUserId').value.toString(),
    )
      .then(async (res: any) => {
        if (res?.data?.length > 0) {
          setTimeout(() => {
            setDataPhoneValid(res?.data[0]);
            setIsRequestingPhoneValid(false);
          }, 500);
          // CreateAlert({ message: 'Phone number is valid', type: 'success' });
        } else {
          setTimeout(() => {
            setDataPhoneValid([]);
            setIsRequestingPhoneValid(false);
          }, 500);
          // CreateAlert({ message: 'Phone number is invalid', type: 'danger' });
        }
      })
      .catch((err: any) => {
        setTimeout(() => {
          setDataPhoneValid(null);
          setIsRequestingPhoneValid(false);
        }, 500);
        // CreateAlert({ message: err.message, type: 'danger' });
      })
      .finally(() => {
        setTimeout(() => {
          setIsRequestingPhoneValid(false);
        }, 500);
      });
  };

  useEffect(() => {}, []);

  return (
    <div className='container-fluid transfer-to-user'>
      <div className='row'>
        <div className='col-4 transfer-to-user__form__col'>
          <div className='transfer-to-user__form'>
            <div className='transfer-to-user__form__title'>TRANSFER</div>
            <div className='transfer-to-user__form__input'>
              <div className='row'>
                <div className='col-12'>
                  <InputWraper
                    label={'Transfer to'}
                    inputProps={getInputProps('toUserId')}
                    alert={
                      dataPhoneValid != null
                        ? dataPhoneValid.length === 0
                          ? {
                              alertType: 'danger',
                              alertContent: 'Recipient not found',
                            }
                          : {
                              alertContent: [
                                <span style={{ color: '#4fff00' }}>
                                  Recipient:{' '}
                                </span>,
                                <span style={{ color: '#fff' }}>
                                  {dataPhoneValid?.fullName ?? 'N/A'}
                                </span>,
                              ],
                            }
                        : null
                    }
                    renderInput={(props) => (
                      <InputText
                        {...props}
                        onTouched={handleCheckPhoneValid}
                        onFocus={() => setDataPhoneValid(null)}
                      />
                    )}
                  />
                </div>
                <div className='col-12'>
                  {isRequestingPhoneValid === true && (
                    <div className='spinner-grow text-primary' role='status'>
                      <span className='sr-only'>Loading...</span>
                    </div>
                  )}
                </div>
                <div className='col-12'>
                  <InputWraper
                    label={'Amount'}
                    inputProps={getInputProps('amount')}
                    component={InputNumber}
                  />
                </div>
                <div className='col-12'>
                  <InputWraper
                    label={'Reason'}
                    inputProps={getInputProps('reason')}
                    component={InputText}
                  />
                </div>
              </div>
            </div>
            <div className='transfer-to-user__form__action'>
              <Button
                className='transfer-button'
                type='submit'
                label='Transfer'
                buttonType='success'
                onClick={handleSubmit}
                isLoading={isSubmitting}
                disabled={
                  isSubmitting ||
                  dataPhoneValid == null ||
                  dataPhoneValid.length === 0 ||
                  isRequesting ||
                  isRequestingPhoneValid
                }
              />
            </div>
          </div>
        </div>
        <div className='col-8 transfer-to-user__banner__col'>
          <div className='transfer-to-user__banner'>
            <img
              className='transfer-to-user__banner__img'
              src='/assets/images/transfer-banner.png'
              alt=''
            />
          </div>
        </div>
      </div>
    </div>
  );
});
